import { z } from 'zod';
import { codigoContabilBody } from './plano.js';

/**
 * Contas patrimoniais — as contas de balanco usadas na provisao.
 *
 * O plano financeiro cobre o resultado (receita e despesa). Quando um
 * lancamento e exportado em regime de competencia, ele nao vai direto do plano
 * para o banco: passa por uma conta de balanco (Fornecedores, Clientes,
 * Adiantamentos). Essa conta e o unico dado contabil que nao cabia nem no plano
 * nem no cadastro de bancos, e por isso tem cadastro proprio.
 *
 * Sem grupo e sem natureza de proposito: quem escolhe a conta e a pessoa, linha
 * a linha, na tela de exportacao — nao ha regra automatica para inferir.
 */

export interface ContaPatrimonial {
  id: number;
  nome: string;
  codigo_contabil: string | null;
  /** Conta desativada some do seletor mas continua valendo no historico. */
  is_active: boolean;
  /** Quantos lancamentos ja apontam para ela. Decide excluir vs desativar. */
  em_uso: number;
}

export const contaPatrimonialBody = z.object({
  nome: z
    .string()
    .trim()
    .min(2, 'O nome precisa de ao menos 2 caracteres.')
    .max(128, 'O nome passa de 128 caracteres.'),
  is_active: z.boolean().optional(),
  codigo_contabil: codigoContabilBody,
});

export type ContaPatrimonialBody = z.infer<typeof contaPatrimonialBody>;

/** So as ativas, na ordem de cadastro — alimenta o seletor da exportacao. */
export function patrimoniaisAtivas(
  contas: readonly ContaPatrimonial[],
): ContaPatrimonial[] {
  return contas.filter((conta) => conta.is_active);
}
